import { createAsyncThunk } from '@reduxjs/toolkit'

import { UsageReport, UsageReport2 } from 'common/api/v1/types'
import { UsageRequestParams } from '../../api/nm-types'
import { withDefaultPagination } from '../../utils'
import { ThunkApi } from '../../store'
import { enqueueErrorSnackbar } from './notificationActions'

export const readUsage = createAsyncThunk<UsageReport, UsageRequestParams, ThunkApi>(
  'usage/readUsage',
  async ({ startDate, endDate, ...params }, { dispatch, extra: { api } }) => {
    try {
      return await api.usageApi.readUsage({ startDate, endDate, ...withDefaultPagination(params) })
    } catch (err) {
      dispatch(enqueueErrorSnackbar({ error: err, operation: 'fetch usage' }))
      throw err
    }
  },
)

export const readUsage2 = createAsyncThunk<UsageReport2, UsageRequestParams, ThunkApi>(
  'usage/readUsage2',
  async ({ startDate, endDate, ...params }, { dispatch, extra: { api } }) => {
    try {
      return await api.usageApi.readUsage2({ startDate, endDate, ...withDefaultPagination(params) })
    } catch (err) {
      dispatch(enqueueErrorSnackbar({ error: err, operation: 'fetch usage v2' }))
      throw err
    }
  },
)
